/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MonitoredCertificateDtoTimeToExpiration,
    MonitoredCertificateDtoTimeToExpirationFromJSON,
    MonitoredCertificateDtoTimeToExpirationFromJSONTyped,
    MonitoredCertificateDtoTimeToExpirationToJSON,
} from './MonitoredCertificateDtoTimeToExpiration';

/**
 * 
 * @export
 * @interface MonitoredCertificateDto
 */
export interface MonitoredCertificateDto {
    /**
     * 
     * @type {string}
     * @memberof MonitoredCertificateDto
     */
    subjectCN?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoredCertificateDto
     */
    issuerCN?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoredCertificateDto
     */
    thumbPrint?: string;
    /**
     * 
     * @type {Date}
     * @memberof MonitoredCertificateDto
     */
    validFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MonitoredCertificateDto
     */
    validTo?: Date;
    /**
     * 
     * @type {MonitoredCertificateDtoTimeToExpiration}
     * @memberof MonitoredCertificateDto
     */
    timeToExpiration?: MonitoredCertificateDtoTimeToExpiration;
    /**
     * 
     * @type {string}
     * @memberof MonitoredCertificateDto
     */
    validStatus?: string;
}

export function MonitoredCertificateDtoFromJSON(json: any): MonitoredCertificateDto {
    return MonitoredCertificateDtoFromJSONTyped(json, false);
}

export function MonitoredCertificateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredCertificateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subjectCN': !exists(json, 'subjectCN') ? undefined : json['subjectCN'],
        'issuerCN': !exists(json, 'issuerCN') ? undefined : json['issuerCN'],
        'thumbPrint': !exists(json, 'thumbPrint') ? undefined : json['thumbPrint'],
        'validFrom': !exists(json, 'validFrom') ? undefined : (new Date(json['validFrom'])),
        'validTo': !exists(json, 'validTo') ? undefined : (new Date(json['validTo'])),
        'timeToExpiration': !exists(json, 'timeToExpiration') ? undefined : MonitoredCertificateDtoTimeToExpirationFromJSON(json['timeToExpiration']),
        'validStatus': !exists(json, 'validStatus') ? undefined : json['validStatus'],
    };
}

export function MonitoredCertificateDtoToJSON(value?: MonitoredCertificateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subjectCN': value.subjectCN,
        'issuerCN': value.issuerCN,
        'thumbPrint': value.thumbPrint,
        'validFrom': value.validFrom === undefined ? undefined : (value.validFrom.toISOString().substr(0,10)),
        'validTo': value.validTo === undefined ? undefined : (value.validTo.toISOString().substr(0,10)),
        'timeToExpiration': MonitoredCertificateDtoTimeToExpirationToJSON(value.timeToExpiration),
        'validStatus': value.validStatus,
    };
}

